import React from "react";
// nodejs library that concatenates classes
import classNames from "classnames";
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
import parallaxStyle from "assets/jss/material-kit-react/components/parallaxStyle.jsx"

import missingStepCta from "data/the-missing-step-cta-hero.json";

// Sections for this page
import CTASection from "components/CTASection/CTASection.jsx";

import Barren from "components/Background/Barren.jsx";

const missingStepStyle = {

};

class MissingStepCTA extends React.Component {
  render() {
    const { classes, listIds, ...rest } = this.props;
    return (
      <Barren>
        <CTASection id="" cta={missingStepCta} listIds={[27].concat(listIds)} filterOpacity="0.4"/>
      </Barren>
    );
  }
}

export default withStyles(missingStepStyle)(MissingStepCTA);
